import React, { useEffect, useRef } from 'react';
import {
  PauseIcon,
  PlayIcon,
  SpeakerWaveIcon,
} from '../../icons';
import MatDashPanel from '../layout/MatDashPanel';
import { formatPlaybackTime } from '../../utils/audioSync';

const AudioReviewPanel = ({
  audioUrl,
  audioRef,
  currentTime,
  isPlaying,
  onTimeUpdate,
  onTogglePlay,
  durationSeconds,
  onEnded,
  className = '',
}) => {
  if (!audioUrl) {
    return (
      <MatDashPanel title="Audio review" icon={SpeakerWaveIcon} className={className}>
        <div className="flex items-start gap-3 text-matdash-muted">
          <SpeakerWaveIcon className="h-5 w-5 mt-0.5 flex-shrink-0" />
          <div>
            <p className="text-sm font-medium text-matdash-dark">Original audio unavailable</p>
            <p className="text-xs mt-1 mb-0">
              Audio playback will appear here when the recording URL is provided by the API.
            </p>
          </div>
        </div>
      </MatDashPanel>
    );
  }

  const displayDuration = durationSeconds > 0 ? durationSeconds : undefined;

  return (
    <MatDashPanel
      title="Audio review"
      subtitle="Play the original recording while reviewing the transcript."
      icon={SpeakerWaveIcon}
      className={className}
    >
      <audio
        ref={audioRef}
        src={audioUrl}
        preload="metadata"
        onTimeUpdate={onTimeUpdate}
        onEnded={onEnded}
        className="w-full mb-3"
        controls
      />
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={onTogglePlay}
          className="md-btn md-btn-primary inline-flex items-center gap-2"
        >
          {isPlaying ? (
            <PauseIcon className="h-4 w-4" />
          ) : (
            <PlayIcon className="h-4 w-4" />
          )}
          {isPlaying ? 'Pause' : 'Play'}
        </button>
        <span className="text-xs text-matdash-muted">
          {formatPlaybackTime(currentTime)}
          {displayDuration ? ` / ${formatPlaybackTime(displayDuration)}` : ''}
        </span>
      </div>
    </MatDashPanel>
  );
};

export default AudioReviewPanel;
